export const Assigned = 0
export const InProgress = 1
export const Complete = 2

export const course_progress_constant = [
    { value: 0, label: 'Assigned' },
    { value: 1, label: 'In Progress' },
    { value: 2, label: 'Complete' },
]
